import { useState, useEffect } from "react";

const Slide = ({ imageLinks }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  // Keep track of whether we moved "next" or "prev" to change animation direction
  const [direction, setDirection] = useState("next");

  const handlePrev = () => {
    setDirection("prev");
    setActiveIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : imageLinks.length - 1
    );
  };

  const handleNext = () => {
    setDirection("next");
    setActiveIndex((prevIndex) =>
      prevIndex < imageLinks.length - 1 ? prevIndex + 1 : 0
    );
  };

  useEffect(() => {
    // Auto-play every 5 seconds
    const interval = setInterval(() => {
      setDirection("next");
      setActiveIndex((prevIndex) =>
        prevIndex < imageLinks.length - 1 ? prevIndex + 1 : 0
      );
    }, 5000);

    return () => clearInterval(interval);
  }, [imageLinks.length]);

  return (
    <div className="relative w-full lg:w-9/12 mx-auto">
      {/* Image Container */}
      <div className="overflow-hidden relative h-[400px] flex items-center justify-center">
        <img
          key={activeIndex} // Ensure the key changes so the animation can trigger
          src={imageLinks[activeIndex]}
          alt={`slide-${activeIndex}`}
          // We'll apply a conditional animation class based on "direction"
          className={`w-11/12 lg:w-10/12 xl:w-8/12 mx-auto border border-blue-300 
            rounded-lg p-4 object-cover transition-transform duration-500 
            hover:scale-105
            ${direction === "next" ? "animate-slideInRight" : "animate-slideInLeft"}
          `}
        />
        {/* Navigation buttons */}
        <div className="absolute flex justify-between items-center w-full px-4 top-1/2 -translate-y-1/2">
          <button
            onClick={handlePrev}
            className="btn btn-circle h-8 w-8 lg:h-12 lg:w-12 
                       bg-blue-600 text-white hover:bg-blue-800 
                       transition-all duration-300"
          >
            ❮
          </button>
          <button
            onClick={handleNext}
            className="btn btn-circle h-8 w-8 lg:h-12 lg:w-12
                       bg-blue-600 text-white hover:bg-blue-800 
                       transition-all duration-300"
          >
            ❯
          </button>
        </div>
      </div>

      {/* Indicators (Dots) */}
      <div className="flex justify-center mt-4 space-x-2">
        {imageLinks.map((_, index) => (
          <div
            key={index}
            onClick={() => {
              // Set direction depending on whether the chosen index is ahead or behind
              setDirection(index > activeIndex ? "next" : "prev");
              setActiveIndex(index);
            }}
            className={`cursor-pointer h-3 w-3 rounded-full 
              transition-all duration-300
              ${
                index === activeIndex
                  ? "bg-blue-600 transform scale-125"
                  : "bg-gray-300"
              }`}
          />
        ))}
      </div>

      {/* Custom animations */}
      <style jsx>{`
        /* Slide in from right */
        @keyframes slideInRight {
          0% {
            transform: translateX(100%);
            opacity: 0.4;
          }
          100% {
            transform: translateX(0%);
            opacity: 1;
          }
        }
        /* Slide in from left */
        @keyframes slideInLeft {
          0% {
            transform: translateX(-100%);
            opacity: 0.4;
          }
          100% {
            transform: translateX(0%);
            opacity: 1;
          }
        }
        .animate-slideInRight {
          animation: slideInRight 0.6s ease-in-out forwards;
        }
        .animate-slideInLeft {
          animation: slideInLeft 0.6s ease-in-out forwards;
        }
      `}</style>
    </div>
  );
};

export default Slide;
